import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { GarminAuth } from "./devices/garmin";
import RFSnackbar from "./grading/components/RFSnackbar/RFSnackbar";
import { GradingHome } from "./grading/home";
import MainLayout from "./grading/layout/MainLayout";
import Chat from "./grading/pages/Chat/Chat";
import { InviteHome } from "./grading/pages/Invite/InviteHome";
import LandingPage from "./grading/pages/LandingPage/LandingPage";
import MyLibraryRoutes from "./grading/routes/MyLibraryRoutes";
import theme from "./theme";

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Router>
          <div className="grading-view">
            <div className="grading-body">
              <div className="grading-content">
                <Switch>
                  <Route exact path="/">
                    <Redirect to="/grading" />
                  </Route>
                  <Route path="/grading" component={GradingHome} />
                  <Route path="/app/devices/garmin" component={GarminAuth} />
                  <Route
                    path="/organization/:organizationId"
                    component={LandingPage}
                  />
                  <Route path={"/invite"} component={InviteHome} />
                  <Route
                    path={"/chat"}
                    component={() => (
                      <MainLayout>
                        <Chat />
                      </MainLayout>
                    )}
                  />
                  {MyLibraryRoutes()}
                </Switch>
              </div>
            </div>
          </div>
        </Router>
      </ThemeProvider>
      <RFSnackbar />
    </StyledEngineProvider>
  );
}

export default App;
